import { useQuery } from '@tanstack/react-query';
import { fetchAppSettings, type AppSettings } from '@/lib/network/appSettings';

export const APP_SETTINGS_QUERY_KEY = ['app-settings'] as const;

const DISABLED_SETTINGS: AppSettings = {
  transfersEnabled: false,
  substitutionsEnabled: false,
  captaincyChangesEnabled: false,
  teamTransitionPopupEnabled: false,
};

export const useAppSettings = () => {
  const query = useQuery({
    queryKey: APP_SETTINGS_QUERY_KEY,
    queryFn: fetchAppSettings,
    select: response => response.data,
    staleTime: 10_000,
    refetchInterval: 15_000,
    refetchOnWindowFocus: true,
    retry: 1,
  });

  return { ...query, settings: query.data ?? DISABLED_SETTINGS };
};
